export const prependServerDomain = (url, UStoreProvider) => {
  if (url.startsWith('http')) {
    return url
  }
  const sep = url.startsWith('/') ? '' : '/'
  return `${UStoreProvider.configService.config.serverDomain}${sep}${url}`
}
